import PropTypes from 'prop-types'
import { CSSTransition } from 'react-transition-group'

const Tooltip = ({id, className, content, visible}) => {
  return (
    <CSSTransition
      in={visible}
      timeout={300}
      classNames="fade"
      unmountOnExit
    >
      <div id={id} className={`tooltip ${className}`}>{content}</div>
    </CSSTransition>
  )
}

Tooltip.propTypes = {
  content: PropTypes.node,
  className: PropTypes.string,
  visible: PropTypes.bool,
  id: PropTypes.string
}

export default Tooltip;